import React from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { UserShape } from '../shapes';
import PropTypes from 'prop-types';

export default class MakePublicProfile extends React.Component {

  static propTypes = {
    user: UserShape,
    onUpdateAccount: PropTypes.func,
    history: PropTypes.object
  }

  state = {
    name: this.props.user.get('name') || '',
    headline: this.props.user.get('headline') || ''
  }

  render() {
    if (this.props.user.get('public')) {
      return (
        <Redirect push to='/account/recommend_people_to_follow_first_run' />
      )
    } else {
      return this.renderForm();
    }
  }

  renderForm() {
    return (
      <div className='make-public-profile'>
        <h2>First, tell people about you.</h2>
        <p>
          Why are you into words? Tell people about it in your headline. People will follow you.
          And your followers will get notified when you tack a new word. This helps them discover
          new words.
        </p>
        <form>
          <div className="form-group">
            <label htmlFor="name">Name (optional)</label>
            <input type="text" autoFocus className="input-text" id="name" value={ this.state.name } autoComplete='off' onChange={ event => this.onNameChanged(event) } placeholder="first and last"></input>
          </div>
          <div className="form-group">
            <label htmlFor="name">Headline</label>
            <input type="text" className="input-text" id="headline" value={ this.state.headline } autoComplete='off' onChange={ event => this.onHeadlineChanged(event) } placeholder="Lover of words."></input>
          </div>
        </form>
        <div className='action'>
          <Link to='/people_board' className='btn btn-outline-secondary'>Nevermind</Link>
          <button onClick={ this.onMakePublic.bind(this) } className='btn btn-dark' data-primary-cta='true'>Next</button>
        </div>
      </div>
    );
  }

  onNameChanged(event) {
    this.setState({ name: event.target.value });
  }

  onHeadlineChanged(event) {
    this.setState({ headline: event.target.value });
  }

  onMakePublic() {
    this.props.onUpdateAccount(this.state.name, this.state.headline, true);
  }
}



// WEBPACK FOOTER //
// ./src/components/make_public_profile.jsx